export default "__VITE_ASSET__4840ed4c__"